import { type MCPServerInfo } from '../../types';

const BullhornCRMServer: MCPServerInfo = {
  serverId: 'BULLHORN_CRM',
  name: 'Bullhorn CRM',
  slug: 'bullhorn-crm',
  description:
    'Query live Bullhorn CRM data — candidates, jobs, placements, contacts, and more — using SQL via the CData JDBC driver.',
  source: {
    sourceType: 'LOCAL_PACKAGE',
    transport: 'STDIO',
    commandFunction: `(config) => ({
  command: 'java',
  args: ['-jar', config.jarPath, config.prpPath],
  env: {}
})`
  },
  authenticationType: 'NONE',
  serverConfig: {
    required: [],
    properties: {}
  },
  installConfig: {
    required: ['jarPath', 'prpPath'],
    properties: {
      jarPath: {
        type: 'string',
        description:
          'Absolute path to CDataMCP-jar-with-dependencies.jar (built from the CData Bullhorn CRM MCP repo)',
        sensitive: false
      },
      prpPath: {
        type: 'string',
        description:
          'Absolute path to your .prp config file with DriverPath, JdbcUrl, and other CData settings',
        sensitive: false
      }
    }
  },
  deprecated: true
};

export default BullhornCRMServer;
